import '.fh{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.fi{padding-left:1.5rem;}.ssr-plugin'
import '.fj{margin:1rem 0;}.ssr-plugin'
import '.fk{color:var(--gray-700);}.ssr-plugin'
import '.fl{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="fh fi fj fk fl"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
